import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from "@angular/material/icon";
import { MatDrawerMode, MatSidenav, MatSidenavContent, MatSidenavModule } from '@angular/material/sidenav';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { map } from 'rxjs/operators';
import { MatButtonModule } from '@angular/material/button';
import { OnInit, Inject, OnDestroy } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { MatMenu, MatMenuModule, MatMenuTrigger } from '@angular/material/menu';
import { Observable, Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { CommonModule } from '@angular/common';
import { Route, Router, RouterLink, RouterModule } from '@angular/router';
import { RouterOutlet } from '@angular/router';
import { MsalService, MsalModule, MsalBroadcastService, MSAL_GUARD_CONFIG, MsalGuardConfiguration } from '@azure/msal-angular';
import { AuthenticationResult, InteractionStatus, PopupRequest, RedirectRequest, EventMessage, EventType } from '@azure/msal-browser';

import { ExecService } from '../../../services/exec.service';
import { ProfileType } from '../../../models/profiletype.model';
import { NavigationService } from '../../../services/navigationService';
import { RoleService } from '../../../services/role.service';
import { Title } from '@angular/platform-browser';
@Component({
  selector: 'app-header',
  imports: [
    MatToolbarModule,
    MatIconModule,
    CommonModule, MsalModule, RouterOutlet, MatButtonModule, MatMenuModule, RouterModule
  ],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss'
})
export class HeaderComponent implements OnInit, OnDestroy {
  profile: ProfileType | undefined;
  isIframe = false;
  loginDisplay = false;
  private readonly _destroying$ = new Subject<void>();
  headerTitle$: Observable<string>;
  @Output() toggleSidenav = new EventEmitter<void>();
  constructor(
    @Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration,
    private authService: MsalService,
    private msalBroadcastService: MsalBroadcastService,
    private execService: ExecService,
    private router: Router,
    private navService: NavigationService,
    private roleService: RoleService,
    private titleService: Title
  ) { 
    this.headerTitle$ = this.navService.currentTitle$;
  }

  public ngOnInit(): void {

    // this.authService.instance.handleRedirectPromise().then((response) => {
    //   if (response) {
    //     alert('respoce');
    //     //Redirect to the inner page after successful login
    //     this.router.navigate(['/acronym']); // Replace with your desired inner page
    //   }
    // });
    this.navService.currentTitle$
      .subscribe(title => {
        this.titleService.setTitle(title);
      });

    this.authService.handleRedirectObservable().subscribe();
    this.isIframe = window !== window.parent && !window.opener; // Remove this line to use Angular Universal

    this.setLoginDisplay();

    this.authService.instance.enableAccountStorageEvents(); // Optional - This will enable ACCOUNT_ADDED and ACCOUNT_REMOVED events emitted when a user logs in or out of another tab or window
    this.msalBroadcastService.msalSubject$
      .pipe(
        filter((msg: EventMessage) => msg.eventType === EventType.ACCOUNT_ADDED || msg.eventType === EventType.ACCOUNT_REMOVED),
      )
      .subscribe((result: EventMessage) => {
        if (this.authService.instance.getAllAccounts().length === 0) {
          window.location.pathname = "/";
        } else {
          this.setLoginDisplay();
        }
      });

    this.msalBroadcastService.inProgress$
      .pipe(
        filter((status: InteractionStatus) => status === InteractionStatus.None),
        takeUntil(this._destroying$)
      )
      .subscribe(() => {
        this.setLoginDisplay();
        this.checkAndSetActiveAccount();
        this.getProfile();

      })

    this.getProfile();

  }

  open(menu: any) {
    menu.openMenu();
  }

  setLoginDisplay() {
    console.log('Checking login status. Accounts:', this.authService.instance.getAllAccounts());
    this.loginDisplay = this.authService.instance.getAllAccounts().length > 0;
    this.checkAndSetActiveAccount();
  }

  checkAndSetActiveAccount() {
    let activeAccount = this.authService.instance.getActiveAccount();
    
    console.log('Active Accounts:', this.authService.instance.getAllAccounts());
    if (!activeAccount && this.authService.instance.getAllAccounts().length > 0) {
      let accounts = this.authService.instance.getAllAccounts();
      this.authService.instance.setActiveAccount(accounts[0]);
    }

    
    if(activeAccount){
      let userName = activeAccount?.name || activeAccount?.idTokenClaims?.["name"];
      
      console.log('users claims:', activeAccount?.idTokenClaims, "username stoed in local variable:", userName);
      localStorage.setItem("loggedUserName", userName || "");

      const claims = activeAccount.idTokenClaims as any;
      if (claims?.roles) {
        const roles: string[] = Array.isArray(claims.roles) ? claims.roles : [claims.roles];
        console.log('Roles found in ID Token:', roles);
        this.roleService.setRoles(roles); // ← BehaviorSubject emits here
      } else {
        console.warn('No roles found in token.');
        this.roleService.setRoles(['NoRole']); // emit empty so consumers don't wait forever
      }
    }
    var roles = activeAccount?.idTokenClaims?.roles
  }

  loginRedirect() {
    if (this.msalGuardConfig.authRequest) {
      this.authService.loginRedirect({ ...this.msalGuardConfig.authRequest } as RedirectRequest);
    } else {
      this.authService.loginRedirect();
    }
  }

  loginPopup() {
    if (this.msalGuardConfig.authRequest) {
      this.authService.loginPopup({ ...this.msalGuardConfig.authRequest } as PopupRequest)
        .subscribe((response: AuthenticationResult) => {
          this.authService.instance.setActiveAccount(response.account);
        });
    } else {
      this.authService.loginPopup()
        .subscribe((response: AuthenticationResult) => {
          this.authService.instance.setActiveAccount(response.account);
        });
    }
  }

  logout(popup?: boolean) {
    if (popup) {
      this.authService.logoutPopup({
        mainWindowRedirectUri: "/"
      });
    } else {
      this.authService.logoutRedirect();
    }
  }

  getProfile() {

    this.execService.getProfile().subscribe(profile => {
      this.profile = profile;
    });
  }



  ngOnDestroy(): void {
    this._destroying$.next(undefined);
    this._destroying$.complete();
  }

}
